import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const ASSET_BASE = BACKEND_URL;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const fileUrl = (relativeOrAbsolute) => {
  if (!relativeOrAbsolute) return "";
  if (relativeOrAbsolute.startsWith("http")) return relativeOrAbsolute;
  return `${ASSET_BASE}${relativeOrAbsolute}`;
};
